<template>
  <v-card
    :elevation="elevation"
    outlined
    tile
    :loading="this.text == undefined"
    style="cursor: pointer;"
    :to="'/workplaces/' + workplace.id"
  >
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-subtitle>
          <v-icon v-if="icon != ''" class="mx-2" :color="iconColor" dark>{{icon}}</v-icon>
          {{title}}
        </v-list-item-subtitle>
        <v-list-item-title class="title mb-1">{{text}}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    bgColor: {
      type: String,
      default: "white"
    },
    color: {
      type: String,
      default: "secondary"
    },
    elevation: {
      type: [Number, String],
      default: 0
    },
    inline: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, String],
      default: 24
    },
    title: {
      type: String,
      default: undefined
    },
    icon: {
      default: ""
    },
    iconColor: {
      default: "primary"
    },
    workplace: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      text: undefined
    };
  },
  created() {
    this.initialize(this.workplace.id);
  },
  methods: {
    initialize(workplaceId) {
      this.services
        .workplaceService()
        .getWorkplaceTasksCount(workplaceId)
        .then(response => {
          this.text = response.data;
        });
    }
  }
};
</script>